import { render, staticRenderFns } from "./shopAwardList.vue?vue&type=template&id=075d7cbe&scoped=true&"
import script from "./shopAwardList.vue?vue&type=script&lang=js&"
export * from "./shopAwardList.vue?vue&type=script&lang=js&"
import style0 from "./shopAwardList.vue?vue&type=style&index=0&id=075d7cbe&lang=scss&scoped=true&"
import style1 from "./shopAwardList.vue?vue&type=style&index=1&id=075d7cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075d7cbe",
  null
  
)

export default component.exports